import React from "react";
import { IKYXSingpass } from "Views/KYX/@types";

import { VerifySingpass } from "Views/KYX/Progress/Step/Second/Form/MyInfo/VerifySingpass";

export const KYXVerifySingpass = (props: IKYXSingpass) => {
  return <VerifySingpass {...props} />;
};
